import {
  InputAdornment,
  TextFieldProps as MUITextFieldProps,
} from '@mui/material';
import Button, { ButtonProps } from '../Button';
import TextField from '../TextField';
import Box from '../Box';
import { mergeSX } from '../../services/helpers';

const buildSX = () => ({
  padding: 0,
  height: '48px',
  '&.MuiOutlinedInput-root .MuiInputAdornment-root': {
    paddingRight: 0,
  },
});

export interface ITextInputButtonProps extends ButtonProps {
  text?: string;
}

export type ITextFieldWithButtonProps = MUITextFieldProps & {
  buttonProps?: ITextInputButtonProps,
}

const TextFieldWithButton = (props: ITextFieldWithButtonProps) => {
  const {
    buttonProps = {}, InputProps = {}, sx, ...rest
  } = props;
  const { endAdornment: inputEndAdornment = null, ...restInputProps } = InputProps;
  const { text } = buttonProps;

  return (
    <TextField
      InputProps={{
        sx: mergeSX(buildSX(), sx),
        endAdornment: (
          <InputAdornment position="end">
            {inputEndAdornment && (
              <>
                {inputEndAdornment}
                <Box mr={1} />
              </>
            )}
            <Button
              disableMinWidth
              padding="8px"
              borderRadius="0px 16px 16px 0px"
              {...buttonProps}
            >
              {text}
            </Button>
          </InputAdornment>
        ),
        ...restInputProps,
      }}
      {...rest}
    />
  );
};

export default TextFieldWithButton;
